export default __webpack_public_path__ + "static/media/email.143a7f65.svg";